import countryService from '../Services/countryService';

const urlMappings = {
  local: {
    api: 'http://local.vacanted.com.{countryCode}:8080',
    app: 'http://local.vacanted.com.{countryCode}:3000',
    panel: 'http://local.vacanted.com.{countryCode}:3002',
    login: 'http://local.vacanted.com.{countryCode}:3000/auth/login',
    search: 'http://local.vacanted.com.{countryCode}:3000/search',
    vacantest: 'http://local.vacanted.com.{countryCode}:3000/vacantest',
  },
  development: {
    api: 'https://develop.vacanted.com.{countryCode}/api',
    app: 'https://develop.vacanted.com.{countryCode}',
    panel: 'https://panel-dev.vacanted.com.{countryCode}',
    login: 'https://develop.vacanted.com.{countryCode}/auth/login',
    search: 'https://develop.vacanted.com.{countryCode}/search',
    vacantest: 'https://develop.vacanted.com.{countryCode}/vacantest',
  },
  qa: {
    api: 'https://qa.vacanted.com.{countryCode}/api',
    app: 'https://qa.vacanted.com.{countryCode}',
    panel: 'https://panel-qa.vacanted.com.{countryCode}',
    login: 'https://qa.vacanted.com.{countryCode}/auth/login',
    search: 'https://qa.vacanted.com.{countryCode}/search',
    vacantest: 'https://qa.vacanted.com.{countryCode}/vacantest',
  },
  production: {
    api: 'https://vacanted.com.{countryCode}/api',
    app: 'https://vacanted.com.{countryCode}',
    panel: 'https://panel.vacanted.com.{countryCode}',
    login: 'https://vacanted.com.{countryCode}/auth/login',
    search: 'https://vacanted.com.{countryCode}/search',
    vacantest: 'https://vacanted.com.{countryCode}/vacantest',
  },
};

const vacantedEnvironment = process.env.REACT_APP_VACANTED_ENV || 'local';

if (!urlMappings[vacantedEnvironment]) {
  throw new Error(`Env ${vacantedEnvironment} is not valid to initialize app`);
}

export const getUrl = (component) => {
  const detectedCountryCode = countryService.getCurrentCountryCode();
  const urlTemplate = urlMappings[vacantedEnvironment][component];
  const url = urlTemplate.replace('{countryCode}', detectedCountryCode);
  return url;
};

export const getEnv = () => vacantedEnvironment;
